import React, { useState } from "react";
import { Button, Form, Grid, Message, Segment } from "semantic-ui-react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { docTitle } from "../../../helpers/docTitle";

function SignupForm({ next, prev, current, setCurrent }) {
  docTitle("Signup - SEF");

  const [newUser, setUser] = useState({
    // firstName: "",
    // lastName: "",
    email: "",
    password: "",
    confirmPass: "",
    phone: "",
  });
  const [errors, setErrors] = useState({
    // firstName: false,
    // lastName: false,
    email: false,
    password: false,
    notConfirmed: false,
    phone: false,
    response: { show: false, type: "success", message: "" },
  });
  const [loading, setLoading] = useState(false);

  const handleSignup = async () => {
    try {
      const { confirmPass, email, password, phone } = newUser;
      // if (!newUser.firstName) return setErrors({ ...errors, firstName: true });
      // if (!newUser.lastName) return setErrors({ ...errors, lastName: true });
      if (
        !email ||
        !new RegExp(/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).test(email)
      )
        return setErrors({ ...errors, email: true });
      if (!password) return setErrors({ ...errors, password: true });

      if (password !== confirmPass)
        return setErrors({ ...errors, notConfirmed: true });

      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/user?email=${email}`
      );
      setLoading(false);
      if (response.status === 200) {
        localStorage.setItem(
          "user",
          JSON.stringify({ email, password, phone })
        );

        return next();
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 409) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error.response.status === 500) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: "Something went wrong, please try again later",
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  return (
    <Grid textAlign="center">
      <Grid.Column style={{ maxWidth: 450 }}>
        {/* <Image src={logo} centered /> */}
        {/* <Header as='h2' color='green' textAlign='center'>
          Create new account
        </Header> */}
        {errors.response.show ? (
          <Message
            error={errors.response.type === "error"}
            success={errors.response.type === "success"}
          >
            {errors.response.message}
          </Message>
        ) : null}
        <Form size="large">
          <Segment raised>
            {/* <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              placeholder='First Name'
              error={errors.firstName}
              onChange={(e) => {
                setUser({ ...newUser, firstName: e.target.value });
                setErrors({ ...errors, firstName: false });
              }}
            />
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              placeholder='Last Name'
              error={errors.lastName}
              onChange={(e) => {
                setUser({ ...newUser, lastName: e.target.value });
                setErrors({ ...errors, lastName: false });
              }}
            /> */}
            <Form.Input
              fluid
              icon="mail"
              iconPosition="left"
              placeholder="E-mail address"
              error={
                errors.email
                  ? {
                      content: "Please enter a valid email address",
                      pointing: "below",
                    }
                  : false
              }
              onChange={(e) => {
                setUser({ ...newUser, email: e.target.value });
                setErrors({ ...errors, email: false });
              }}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              error={errors.password}
              onChange={(e) => {
                setUser({ ...newUser, password: e.target.value });
                setErrors({ ...errors, password: false });
              }}
            />
            <Form.Input
              fluid
              icon="check circle"
              iconPosition="left"
              placeholder="Confirm Password"
              type="password"
              error={
                errors.notConfirmed && newUser.password !== newUser.confirmPass
              }
              onChange={(e) => {
                setUser({ ...newUser, confirmPass: e.target.value });
                // if (newUser.password !== newUser.confirmPass)
                //   return setErrors({ ...errors, notConfirmed: true });
              }}
            />
            <Form.Input
              fluid
              icon="phone"
              iconPosition="left"
              placeholder="Phone"
              error={errors.phone}
              onChange={(e) => {
                setUser({ ...newUser, phone: e.target.value });
                setErrors({ ...errors, phone: false });
              }}
            />
            {/* <Checkbox
              label='By signing up, I agree to the Terms & Conditions'
              style={{ padding: 10 }}
              onChange={() => setChecked(!checked)}
            /> */}
            {/* <Container fluid className='w-100'> */}
            <Row className="d-flex align-items-center">
              <Col className="" lg={9}>
                <Button
                  color="dodge blue"
                  fluid
                  size="large"
                  loading={loading}
                  circular
                  // disabled={!checked}
                  onClick={handleSignup}
                >
                  Next
                </Button>
              </Col>
              <Col className="" lg={1}>
                {/* <Button
                  negative
                  fluid
                  size='large'
                  loading={loading}
                  // disabled={!checked}
                  onClick={handleSignup}
                >
                  Previous
                </Button> */}
                <Button
                  icon="arrow left"
                  circular
                  onClick={() => setCurrent(current - 1)}
                />
              </Col>
            </Row>

            {/* {current > 0 && (
              
            )} */}
            {/* </Container> */}
          </Segment>
        </Form>
        <Message floating>
          Already have an account? <Link to="/auth">Sign In</Link>
        </Message>
      </Grid.Column>
    </Grid>
  );
}

export default SignupForm;
